jQuery($ => {
	$('.js-filter-mobile-toggle').click(function() {
		$(this).toggleClass('open');
	});

	$('.js-filter-category-toggle').click(function(e) {
		e.preventDefault();
		$(this).toggleClass('open');
	});

	$('.js-filter-category-all').change(function() {
		const allBtnState = $(this).prop('checked');

		$(this)
			.closest('.filter__container')
			.find('.filter__categories-dropdown input')
			.each(function() {
				$(this).prop('checked', allBtnState);
			});

		if($(this).is(':checked')){
			$('.js-filter-category-toggle').addClass('open');
		}else{
			$('.js-filter-category-toggle').removeClass('open');
		}
	});

	$(document).on('change', '#filter-by-my-interests', function(){
		const myInterests = $(this).data('interests');

		if($(this).is(':checked')){
			$('.js-filter-category-toggle').addClass('open');
			$(this)
				.closest('.filter__container')
				.find('.filter__categories-dropdown input')
				.each(function() {
					if(_.isArray(myInterests) && _.indexOf(myInterests, $(this).attr('value')) !== -1){
						$(this).prop('checked', true);
					}else{
						$(this).prop('checked', false);
					}
				});
		}else{
			$('.js-filter-category-toggle').removeClass('open');
		}
	});
});
